import { render } from "./ProfileSectionHeader.vue?vue&type=template&id=33526a30&scoped=true"
import script from "./ProfileSectionHeader.vue?vue&type=script&lang=js"
export * from "./ProfileSectionHeader.vue?vue&type=script&lang=js"

import "./ProfileSectionHeader.vue?vue&type=style&index=0&id=33526a30&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33526a30"]])

export default __exports__